<template>
  <v-card>
    <v-card-title class="green lighten-4 primary--text font-weight-bold"
      >Orientações Indicação PCD</v-card-title
    >
    <v-card-text class="pt-6" v-html="configPcd.orientacoes_pcd"></v-card-text>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState("pcd", ["configPcd"]),
};
</script>

<style>
</style>